module.exports = __webpack_public_path__ + "static/media/automatedcontent_section3.ddf2b492.png";